<template>
  <div>
    <div class="container">
      <div class="nav">
        <div class="nav-top">
          <p>
            <!-- 响应式网站代码 -->
            <img
              src="../assets/logo.png"
              alt="RSANTAN SAS DE CV"
              style="width: 180px; height: 90px;object-fit: cover"
            />
          </p>
          <p class="header-item">
            <router-link :to="{ name: 'home' }">INICIO</router-link>
            <router-link :to="{ name: 'info' }"
              >TÉRMINOS Y CONDICIONES</router-link
            >
          </p>
          <div><button class="btn">Aplica ya</button></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "headerView",
};
</script>


<style lang="scss" scoped>
.container {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background: #ffffff;
  border:#f1f1f1 1px solid;
}

.nav {
  max-width: 1140px;
  padding: 5px 0;
  margin: 0 auto;

  .nav-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    > p:first-child {
      display: inline-block;
      position: relative;
      color: #1c3655;
      font-size: 14px;
    }

    .btn {
      background: #42b35c;
      border: medium none;
      border-radius: 6px;
      color: #fff;
      font-size: 15px;
      font-weight: 500;
      padding: 7px 15px;
      transition: all 0.3s linear 0s;
      -moz-transition: all 0.3s linear 0s;
      -o-transition: all 0.3s linear 0s;
      -webkit-transition: all 0.3s linear 0;
      cursor: pointer;
    }
  }
}

.header {
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  &-item {
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    a {
      padding: 15px 30px;
      text-decoration: none;
      margin: 0 10px;
      font-size: 15px;
      font-weight: 500;
      color: #000;
    }
    a:hover {
      background: #ecfaf2;
      border-radius: 10px;
      transition: 0.3s;
    }
  }
}
</style>